import { IconProps } from "../types/icon";

export const CoffeeMugIcon = ({
  className = "",
  size = 16,
  color = "currentColor",
  ...props
}: IconProps) => {
  return (
    <svg
      width={size}
      height={size}
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      fill="none"
      viewBox="0 0 16 16"
    >
      <g fill={color}>
        <path d="M8 0H6v3h2zM4 0H2v3h2zM12 0h-2v3h2zM15 5H1c-.6 0-1 .4-1 1v7c0 1.7 1.3 3 3 3h7c1.7 0 3-1.3 3-3v-2c1.7 0 3-1.3 3-3V6c0-.6-.4-1-1-1m-1 3c0 .6-.4 1-1 1V7h1z" />
      </g>
    </svg>
  );
};
